export const NO_HALLADO_FALLECIO = 1;
export const HABIDO = 2;
export const NO_HALLADO_DESTINATA = 3;
export const NO_HALLADO_SE_MUDO = 4;
export const NO_APLICABLE = 5;
export const NO_HALLADO_CERRADO = 6;
export const POR_VERIFICAR = 7;
export const NO_HALLADO_RECHAZADO = 8;
export const NO_HABIDO = 8;
export const NO_HALLADO_OTROS_MOT = 10;
export const NO_HALLADO = 11;
export const PENDIENTE = 12;
export const NO_HALLADO_NO_EXISTE = 13;
export const NO_HALLADO_NRO_PUERT = 14;